export default {
  name: 'distributor-advantage',
  path: '/distributor/advantage',
  component: () => import(`./index.vue`),
  meta: {
      skip_check_token: true,
  },
};
